<template>
  <div class="index-module_articleWrap_2Zphx">
      <div  class="zhemo">文华财经小课堂 - 如何用wh5投资一篮子股票</div>
        <p class="index-module_textWrap_3ygOc">好机构为什么收益稳定，抗风险能力强？
        </p>
        <p class="index-module_textWrap_3ygOc">因为好机构投资的是一篮子股票，具备一套“自上而下”的针对一篮子股票的投资逻辑和完整的分析方法。
        </p>
        <p class="index-module_textWrap_3ygOc">机构研究员从宏观、中观、微观角度出发，通过研判宏观周期，挖掘热点行业，构建投资组合，寻找买入时机，最终投资一篮子股票，获得稳定收益。</p>
        <p class="index-module_textWrap_3ygOc">
            本期将介绍wh5一篮子股票投资工具，讲述如何使用工具软件进行宏观、行业分析，构建投资组合。
        </p>
         <div class="info table2">
            <table cellpadding="7" cellspacing="0" style="width: 730px;background: #f7f9fc;text-indent:0">
                <tr class="center">
                    <th valign="top" style="width:120px">题目</th>
                    <th valign="top">内容</th>
                    <th valign="top" width="9%">讲师</th>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">宏观数据</td>
                    <td>宏观周期性研究<br>
                    【描述】软件采取四分法对宏观经济数据和金融小周期波动进行划分，为大类资产配置和市场择时提供分析工具。<br>
                    【目标】投资宏观经济利好正相关的行业。</td>
                    <td rowspan="4"  style="padding:0 5px;text-align:center;text-indent:0">孙健</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">行业中心</td>
                    <td>热点行业挖掘<br>
                    【描述】从行业市场表现、行业估值、财务数据、行业内上市公司以及行业研究热点五个方面，深入解析行业之间及行业内部的情况，判定行业生命周期，挖掘最具投资潜力的行业。<br>
                    【目标】投资市场表现好、低估且业绩增速快、发展前景好、竞争力强、热度高的行业。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">对比分析</td>
                    <td>利用基本面衍生数据筛选股票<br>
                    【描述】使用市场表现、盈利能力、现金能力等多个角度的统计分析数据，对好行业内的企业综合打分并排序，筛选好股票。<br>
                    【目标】将综合得分高的股票加入投资组合。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">历史分析</td>
                    <td>利用一篮子股票的净值确定买入时机<br>
                    【描述】构建投资组合，通过分析一篮子股票的净值处于历史净值的百分位确定入场时机。<br>
                    【目标】当前净值处于历史净值低位时进行投资。</td>
                </tr>
            </table>
        </div>
        <div  class="index-module_textWrap_3ygOc">
                讲师介绍：
        </div>
        <!-- <div>【孙健】&nbsp;文华产品经理</div> -->
            <div  class="index-module_textWrap_3ygOc">
              【孙健】  &nbsp;文华财经大客户业务部产品经理，十年来专注于客户需求整理和产品设计，每年多次在全国范围内举办和参与期货和证券领域的大型授课活动，现主要负责服务机构客户，为专业的投资者提供技术支持，解决实际使用中的问题。
        </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.info,
.SignUp {
    color: #646464;
    line-height: 180%;
    padding: 0 0 3px 2em;
    font-size: 14px;
}
.info table{
    border: 1px solid #d1d7d7;
    border-collapse: collapse;
}

.info_2 {
    color: #646464;
    line-height: 180%;
    padding-bottom: 3px;
}

.info table {
    width: 688px;
}

.info th {
            padding: 5px 0;

    height: 24px;
    line-height: 24px;
    background: #a4bce2;
    color: #ffffff;
    border: 1px solid #d1d7d7;
    font-size: 14px;
    font-weight: normal;
    text-align: center;
}

.info td {
    padding: 0;
     padding: 5px 8px;

    border: 1px solid #d1d7d7;
    vertical-align: middle;
    padding-left: 8px;
}

.info td.time {
    color: #002c6f;
}

.td_w,.td_b{
    line-height: 29px;
    padding: 0 0 0 22px;
    font-size: 14px;
    color: #646567;
}

.td_b{
    background: #eef0fd;
}
.table2 tr td:first-child{
    text-align: left !important;
    padding-left: 10px !important;
}
</style>